import { trackEvent, AnalyticsCategory } from '@nx-frontend/shared/analytics';
import { PaywallPopupReason } from '@nx-frontend/shared/types';
import { BillingPlanCode } from '@nx-frontend/shared/types/paywall-types';

export function trackTrialStartShowPopup() {
  trackEvent('show', AnalyticsCategory.TRIAL_START_POPUP, '');
}

export function trackTrialStartPopupSelectPlan(plan: BillingPlanCode | 'free') {
  trackEvent('select', AnalyticsCategory.TRIAL_START_POPUP, '', { plan });
}

export function trackTrialStartPopupBookACall(reason: string) {
  trackEvent('click', AnalyticsCategory.TRIAL_START_POPUP, 'book_a_call', { reason });
}

export function trackUpgradePopupBookACall(reason: string) {
  trackEvent('click', AnalyticsCategory.UPGRADE_POPUP, 'book_a_call', { reason });
}

export function trackTrialEndShowPopup() {
  trackEvent('show', AnalyticsCategory.TRIAL_END_POPUP, '');
}

export function trackTrialEndPopupSelectPlan(plan: BillingPlanCode | 'free', time: number) {
  trackEvent('select', AnalyticsCategory.TRIAL_END_POPUP, '', {
    plan,
    time,
  });
}

export function trackTrialEndPopupBookACall(reason: string) {
  trackEvent('click', AnalyticsCategory.TRIAL_END_POPUP, 'book_a_call', { reason });
}

export function trackUpgradeShowPopup(reason: PaywallPopupReason) {
  trackEvent('show', AnalyticsCategory.UPGRADE_POPUP, '', { reason });
}

export function trackUpgradePopupSelectPlan(plan: BillingPlanCode, reason: PaywallPopupReason, time: number) {
  trackEvent('select', AnalyticsCategory.UPGRADE_POPUP, '', {
    plan,
    reason,
    time,
  });
}

export function trackUpgradePopupClose(reason: PaywallPopupReason, time: number) {
  trackEvent('click', AnalyticsCategory.UPGRADE_POPUP, 'close', { reason, time });
}

export function trackUpgradePupopConfirm(plan: BillingPlanCode, reason: PaywallPopupReason, time: number) {
  trackEvent('confirm', AnalyticsCategory.UPGRADE_POPUP, '', {
    plan,
    reason,
    time,
  });
}
